var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLsl = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2682C0 14.138 0.427828 15.9079 1.19072 17.4856L12 18.0073L22.8093 17.4856C23.5722 15.9079 24 14.138 24 12.2682C24 10.3983 23.5722 8.62844 22.8093 7.05082L12 6.52905L1.19072 7.05077C0.427828 8.62844 0 10.3983 0 12.2682Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.2687C16.7582 24.2687 20.869 21.5 22.81 17.4861H1.19141C3.13241 21.5 7.24316 24.2687 12.0007 24.2687Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.267334C7.24316 0.267334 3.13241 3.03601 1.19141 7.04996H22.8099C20.869 3.03601 16.7582 0.267334 12.0007 0.267334Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7838 12.008V9.13843H11.2186V12.008L9.32812 13.8985C9.87792 14.7985 10.8694 15.3993 12.0012 15.3993C13.1331 15.3993 14.1245 14.7985 14.6743 13.8985L12.7838 12.008Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLsl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LSL.0449842d818bf5cc11b10717cf0ead7a.svg";